import { useQuery } from "react-query";
import { api } from "utils/api";
import type { ReviewResponse } from "../types";
import { reviewKeys } from "./queryKeys";

const getReviewsByBadge = (badge: string) =>
  api.get<ReviewResponse>(
    `/reviews?badge=${encodeURIComponent(badge)}&perPage=6`
  );

const useReviewsByBadge = (badge: string) =>
  useQuery(reviewKeys.badgeList(badge), () => getReviewsByBadge(badge));

export { useReviewsByBadge };
